import { FORWARD_PREFIX } from '#constants';

export function buildQueryParams(params: Record<string, string>): string {
  return encodeURIComponent(new URLSearchParams(params).toString());
}

export function getQueryParams(queryParamMap: Record<string, string>): string {
  const queryParamList = [];
  for (const key in queryParamMap) {
    const value = queryParamMap[key];
    if (value) {
      queryParamList.push(
        `${key}=${encodeURIComponent(queryParamMap[key] ?? '')}`,
      );
    }
  }
  return encodeURIComponent(queryParamList.join('&'));
}

export function isValidAmazonS3Domain(url: string): boolean {
  // matches: xxx.s3.amazonaws.com
  // matches: xxx.s3.us-west-2.amazonaws.com
  return /.s3(?:\.[a-z0-9-]+[a-z0-9])?.amazonaws.com/g.test(url);
}

/**
 * Transforms image URLs to use API prefix for non-S3 domains
 * This ensures all non-S3 images are served through our API
 */
export function transformImageUrl(imageUrl: string): string {
  if (!imageUrl) return '';

  if (isValidAmazonS3Domain(imageUrl)) {
    return imageUrl;
  }

  try {
    const url = imageUrl.split('//')[1] as string;
    return FORWARD_PREFIX + url.substr(url.indexOf('/'), url.length);
  } catch {
    return '';
  }
}
